import React, { FC, useCallback, useEffect, useState } from 'react'

import { loadStripe, Stripe as StripeClient } from '@stripe/stripe-js'
import { PaymentElement, useElements, useStripe, Elements } from '@stripe/react-stripe-js'

import { StageProps } from 'sdk/react/Pipeline/Stage'

import Divider from '~pc/atoms/Divider'

import Header from '~p/components/organisms/Header'
import FooterButton from '~p/components/atoms/FooterButton'
import LoadingDots from 'components/molecules/LoadingDots'
import { t } from 'translation'

type CheckoutFormProps = {
  handleSubmit: () => void
}

const CheckoutForm: FC<CheckoutFormProps> = ({ handleSubmit }) => {
  const elements = useElements()
  const stripe = useStripe()
  const onSubmit = useCallback(
    async ev => {
      if (!elements) return
      ev.preventDefault()
      const ret = await stripe?.confirmSetup({
        elements,
        redirect: 'if_required',
      })
      console.log('submit', ret)
      handleSubmit()
    },
    [elements, stripe]
  )
  return (
    <form>
      <PaymentElement />
      <br />
      <footer>
        <FooterButton type="button" onClick={onSubmit}>
          {t('Submit')}
        </FooterButton>
        {/* <button type="submit">{t('Submit')}</button> */}
      </footer>
    </form>
  )
}

type Props = Pick<StageProps<'payment-details'>, 'onSubmit' | 'stage' | 'error'> & {
  config: {
    publishableKey: string
    // todo relabel clientSecret
    secretKey: string
  }
}

const Stripe: FC<Props> = ({ stage, config, onSubmit }) => {
  const [promise, setPromise] = useState<Promise<StripeClient | null>>()

  const handleSubmit = useCallback(() => {
    onSubmit({})
  }, [onSubmit])

  useEffect(() => {
    if (!config) return
    setPromise(loadStripe(config.publishableKey))
  }, [config])

  console.log(stage)
  return (
    <section>
      <Header>
        <div className="flex items-center justify-between -mr-8">{t('Payment details')}</div>
      </Header>
      <main className="px-4 sm:p-0">
        <Divider />
        {promise ? (
          <Elements
            stripe={promise}
            options={{
              clientSecret: config.secretKey,
            }}
          >
            <CheckoutForm handleSubmit={handleSubmit} />
          </Elements>
        ) : (
          <LoadingDots className="mt-16" />
        )}
      </main>
    </section>
  )
}

export default Stripe
